"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _headers = require("../../../services/fetch/headers");
var _config = _interopRequireDefault(require("../../../consts/config"));
var _handlers = require("../../../services/fetch/handlers");
const handleResponse = json => {
  if (!("error_code" in json)) {
    return {
      success: true
    };
  }
  return {
    error: json.error_code
  };
};
const appleLink = _ref => {
  let {
    idToken,
    token
  } = _ref;
  const payload = {
    id_token: idToken
  };
  return fetch(`${_config.default.apiAuthUrl}/v1/oauth.apple.link`, {
    method: "POST",
    headers: (0, _headers.getAuthHeaders)(token),
    body: JSON.stringify(payload)
  }).then(response => {
    if (response.status >= 400) {
      return Promise.reject(new Error("API error when linking user"));
    }
    return (0, _handlers.handleJSON)(response);
  }).then(handleResponse);
};
var _default = exports.default = appleLink;